"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getYouboraPluginURL = exports.THEO = void 0;
// youbora plugin source is stored in S3 at
// hudl-content/youbora/[playername]/[youboraPluginVersion]/[source.js]

var THEO = exports.THEO = 'theoplayer2';
var URL_BASE = '//static.hudl.com/youbora/';
var YOUBORA_SOURCE = 'youbora.min.js';
var HTTP = 'http';
var PROTOCOL_HTTPS = 'https:';
var getYouboraPluginURL = exports.getYouboraPluginURL = function getYouboraPluginURL(browserProtocol, player, version) {
  // In electron apps, the default protocol is file:// so
  // we need to force it to use https. In a browser, we can
  // just use whatever protocol was on the page.
  var moduleBaseProtocol = browserProtocol.includes(HTTP) ? browserProtocol : PROTOCOL_HTTPS;
  return "".concat(moduleBaseProtocol).concat(URL_BASE).concat(player, "/").concat(version, "/").concat(YOUBORA_SOURCE);
};